/**
 * 功法数据
 * 每本功法对五行元素有不同的亲和度
 */

import type { Element } from './spiritualRoots';

/** 品质 */
export type TechniqueGrade = '凡品' | '灵品' | '玄品' | '天品';

export interface Technique {
  id: string;
  name: string;
  grade: TechniqueGrade;
  desc: string;
  /** 对五行元素的亲和度（0~2.0） */
  affinity: Record<Element, number>;
  /** 最大层数 */
  maxLayer: number;
  /** 坊市售价（灵石） */
  price: number;
  /** 出售条件：null=永远可买，'sect_xxx'=对应门派才可买 */
  requireSect?: string;
}

export const TECHNIQUES: Technique[] = [
  {
    id: 'basic_breathing',
    name: '基础吐纳术',
    grade: '凡品',
    desc: '最基础的修炼功法，五行均衡但效率低下。几乎所有散修的入门功法。',
    affinity: { '金': 0.4, '木': 0.4, '水': 0.4, '火': 0.4, '土': 0.4 },
    maxLayer: 3,
    price: 50,
  },
  {
    id: 'gengjin_jue',
    name: '庚金诀',
    grade: '灵品',
    desc: '剑宗入门功法，以金系为主导，蕴含锋锐之意。金火灵根者修炼事半功倍。',
    affinity: { '金': 1.3, '木': 0.2, '水': 0.3, '火': 0.8, '土': 0.3 },
    maxLayer: 6,
    price: 200,
  },
  {
    id: 'qingmu_changsheng',
    name: '青木长生功',
    grade: '灵品',
    desc: '丹宗传承功法，取草木生生不息之意。木水灵根者修炼效果最佳。',
    affinity: { '金': 0.2, '木': 1.3, '水': 0.7, '火': 0.1, '土': 0.5 },
    maxLayer: 6,
    price: 200,
  },
  {
    id: 'taiyin_zhenshui',
    name: '太阴真水经',
    grade: '玄品',
    desc: '上古水属功法，传闻来自深海龙宫。水灵根者修炼如鱼得水。',
    affinity: { '金': 0.3, '木': 0.4, '水': 1.7, '火': 0.1, '土': 0.3 },
    maxLayer: 9,
    price: 500,
  },
  {
    id: 'lihuo_fentian',
    name: '离火焚天诀',
    grade: '玄品',
    desc: '火属顶级功法之一，传说修炼至大成可焚山煮海。火灵根者的不二之选。',
    affinity: { '金': 0.2, '木': 0.1, '水': 0.2, '火': 1.9, '土': 0.3 },
    maxLayer: 9,
    price: 500,
  },
  {
    id: 'houtu_guiyuan',
    name: '厚土归元功',
    grade: '灵品',
    desc: '阵宗核心功法，以土为基、包容万象。土灵根者在阵法加持下事半功倍。',
    affinity: { '金': 0.4, '木': 0.3, '水': 0.2, '火': 0.3, '土': 1.4 },
    maxLayer: 6,
    price: 200,
  },
  {
    id: 'xuesha_mogong',
    name: '血煞魔功',
    grade: '灵品',
    desc: '魔宗秘传，以杀证道。虽然修炼速度不及正道顶级功法，但战斗收益极高。',
    affinity: { '金': 0.8, '木': 0.1, '水': 0.4, '火': 0.9, '土': 0.2 },
    maxLayer: 6,
    price: 300,
    requireSect: 'demon',
  },
  {
    id: 'hunyuan_wuqi',
    name: '混元五气诀',
    grade: '天品',
    desc: '传说中的五行均衡功法，对所有灵根都有极高的亲和度。据说是上古大能所创，早已失传，只能在奇遇中获取。',
    affinity: { '金': 1.0, '木': 1.0, '水': 1.0, '火': 1.0, '土': 1.0 },
    maxLayer: 12,
    price: 0, // 非卖品
  },
];

/** 修炼速度加成：每层+15%，即 multipler = 1 + (layer - 1) * 0.15 */
export function getLayerMultiplier(layer: number): number {
  return 1 + (layer - 1) * 0.15;
}

/** 升层消耗 */
export function getUpgradeCost(layer: number): number {
  return 100 * layer;
}
